import consts from "@/consts"
// import {arraySplitIntoChunks} from "@/lib/lib";
import {arrayFilter_OnlyUnique, getApiProps, updateObjectByDiff} from "@/lib/lib";
import i18n from "@/i18n";

const changedField = 'changed__time';

export default {
    state: {
        stops_index: [],
        stops: [],
        stops_last_hour: [],
    },
    actions: {
        fetchStops4Date({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                args = {unitId: '', date: '', ...args}
                if (args.date == 'today' || !args.date) args.date = getters.getDateToday
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.unitId || !args.date) {
                    return reject(false)
                }

                if (args.unitId > 0 && !args.force) {
                    let index = getters.getStopsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                    if (index) {
                        return resolve(true)
                    }
                }

                dispatch('setLastCall', {name: 'fetchStops4Date', args, time: Date.now() / 1000})
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastStops', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchStopsChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('stops', {withAddress: 1, ...args})
                delete params.unitId;delete params.date;delete params.force;
                this.$api.stops.get4Date(args.unitId, args.date, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeStops', response.data)
                            commit('setStopsIndex', {...args, count: response.data.length})
                            if (args.unitId && isToday) {
                                //dispatch('fetchStopsLastTime', args)
                            }
                            if (!args.unitId && response.data.length) {
                                response.data
                                    .map(e => e.unit_id)
                                    .filter(arrayFilter_OnlyUnique)
                                    .forEach(unitId => {
                                        commit('setStopsIndex', {...args, unitId, count: 1})
                                    })
                            }
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchStops4Date', args, inprogress: false})
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastStops', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchStopsChanged', args, inprogress: false})
                        }
                    });
            })
        },
        fetchStops4Period({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.unitId || !args.from || !args.to) {
                    return reject(false)
                }

                // if (args.unitId > 0 && !args.force) {
                //     let index = getters.getStopsIndex.find(i => (i.unitId == args.unitId && ???))
                //     if (index) {
                //         return resolve(true)
                //     }
                // }

                dispatch('setLastCall', {name: 'fetchStops4Date', args, time: Date.now() / 1000})
                dispatch('setLastCall', {name: 'fetchStops4Period', args, time: Date.now() / 1000})
                /* getters.getTimeToday+24h and args.from/to intersect*/
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastStops', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchStopsChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('stops', {withAddress: 1, ...args})
                delete params.unitId;delete params.from;delete params.to;delete params.force;
                this.$api.stops.get4Period(args.unitId, args.from, args.to, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeStops', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchStops4Date', args, inprogress: false})
                        dispatch('setLastCall', {name: 'fetchStops4Period', args, inprogress: false})
                        /* getters.getTimeToday+24h and args.from/to intersect*/
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastStops', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchStopsChanged', args, inprogress: false})
                        }
                    });
            })
        },
        fetchStopsChanged({dispatch, getters}, args) {
            if (!getters.getApiToken) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchLastStops', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchStopsChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            // delete args.date
            args.force = true
            return dispatch('fetchStops4Date', args)
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchLastStops', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchStopsChanged', args, inprogress: false})
                });
        },

        fetchStopsLastTime({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.unitId) {
                    return reject(false)
                }
                let lmsg_time = getters.getUnitsLmsgsByIds[args.unitId]?.time || 0
                if (!(lmsg_time > getters.getTimeToday)) {
                    return resolve(true)
                }
                let today = getters.getDateToday
                //Index today
                let indx_today = getters.getStopsIndex.find(i => i.date == today && i.unitId == args.unitId)
                if (!indx_today) {
                    return resolve(true)
                }
                //trips&parkings time_end
                let time_ends = [
                    getters.getTripsMaxTimeEndByUnitsIds[args.unitId],
                    getters.getParkingsMaxTimeEndByUnitsIds[args.unitId]
                ].filter(t => !!t && t > 0)
                if (!time_ends.length) time_ends = [getters.getTimeToday]
                let time_start = Math.max(...time_ends)

                if (time_start > lmsg_time) {
                    console.warn('fetchStopsLastTime: Lmsg.time', {args, lmsg_time, time_start})
                    return resolve(true)
                }

                dispatch('setLastCall', {name: 'fetchStopsLastTime', args, time: Date.now() / 1000})

                let params = getApiProps('stops', {withAddress: 1, ...args, date: '', 'start-time': time_start})
                delete params.unitId;delete params.date;delete params.force;
                this.$api.stops.getLast(args.unitId, '', params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeStopsLastHour', {unitId: args.unitId, time_start, data: response.data})
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchStopsLastTime', args, inprogress: false})
                    });
            })
        },

        reloadStops({commit, dispatch}, args) {
            commit('clearStops')
            return dispatch('fetchStops4Date', {date: 'today', ...args})
        },

        //sayHello() {}
    },
    mutations: {
        setStopsIndex(state, params) {
            let i = state.stops_index.findIndex(i => i.date == params.date && i.unitId == params.unitId)
            if (i < 0) {
                state.stops_index.push(Object.freeze({...params}))
            } else {
                state.stops_index[i] = Object.freeze({...state.stops_index[i], ...params})
            }
        },
        storeStops(state, nStops) {
            const exactKeys = new Set(state.stops.map(s => `${s.unit_id}|${s.time_start?.utc}|${s.time_end?.utc}`))
            nStops = nStops
                .filter(s => !exactKeys.has(`${s.unit_id}|${s.time_start?.utc}|${s.time_end?.utc}`))
                //.map(s => Object.freeze(s))

            // if(nStops.length) state.stops.push(...nStops)
            if (!nStops.length) return false
            if (!state.stops.length) {
                state.stops = nStops
                return true
            }
            const indexByIdentity = new Map(state.stops.map((st, i) => [`${st.unit_id}|${st.time_start?.utc}`, i]))
            nStops.forEach(function (nStop) {
                const identityKey = `${nStop.unit_id}|${nStop.time_start?.utc}`
                let i = indexByIdentity.has(identityKey) ? indexByIdentity.get(identityKey) : -1
                if (i < 0) {
                    indexByIdentity.set(identityKey, state.stops.length)
                    state.stops.push(Object.freeze(nStop))
                } else
                if (state.stops[i][changedField] != nStop[changedField])
                {
                    // updateObjectByDiff(state.stops[i], nStop)
                    delete nStop.unit_id;delete nStop.time_start;
                    state.stops[i] = Object.freeze({...state.stops[i], ...nStop})
                }
            })
        },

        storeStopsLastHour(state, args) {
            state.stops_last_hour = state.stops_last_hour.filter(st => {
                return st.unit_id != args.unitId || st.time_start?.utc >= args.time_start
            })

            let nStops = args.data
            nStops = nStops
                .filter(st => {
                    return st.time_end?.utc > args.time_start
                })
                .filter(t => !state.stops_last_hour.find(st => {
                    return st.unit_id == t.unit_id
                        && st.time_start?.utc == t.time_start?.utc
                        && st.time_end?.utc == t.time_end?.utc
                }))
            //.map(t => Object.freeze(t))

            // if(nStops.length) state.stops_last_hour.push(...nStops)
            if (!nStops.length) return false
            if (!state.stops_last_hour.length) {
                state.stops_last_hour = nStops
                return true
            }
            nStops.forEach(function (nStop) {
                let i = state.stops_last_hour.findIndex(st => {
                    return st.unit_id == nStop.unit_id
                        && st.time_start?.utc == nStop.time_start?.utc
                    // && st.time_end?.utc == nStop.time_end?.utc
                })
                if (i < 0) {
                    state.stops_last_hour.push(nStop) //(Object.freeze(nStop))
                } else
                {
                    updateObjectByDiff(state.stops_last_hour[i], nStop)
                    // nStop = {...state.stops_last_hour[i], ...nStop}
                    // state.stops_last_hour[i] = nStop //Object.freeze(nStop)
                }
            })
        },

        clearStops(state, {unitId} = {}) {
            if (unitId) {
                state.stops_last_hour = state.stops_last_hour.filter(s => (s.unit_id || s.object_id) != unitId)
                state.stops = state.stops.filter(s => (s.unit_id || s.object_id) != unitId)
                state.stops_index = state.stops_index.filter(i => i.unitId != unitId)
            } else {
                state.stops_last_hour = [];
                state.stops = [];
                state.stops_index = [];
            }
        },
    },
    getters: {
        getStopsIndex(state) {
            return state.stops_index
        },
        getStops(state) {
            return [...state.stops, ...state.stops_last_hour]
        },
        getStopsI18nMessages(state) {
            return [...state.stops, ...state.stops_last_hour]
                .map((eventsTextByXid, event) => {
                    let message = event?.message?.msg;
                    if (message) {
                        let matches = message.matchAll(/\$t{([\w]+)}/gi);
                        Array.from(matches).forEach(match => {
                            let str = event?.message[match[1]] || ''
                            let translateKey = 'message.' + 'events' + '.' + str
                            str = i18n.global.te(translateKey) ? i18n.global.t(translateKey) : str
                            message = message.replace(match[0], str);
                        })
                    }
                    return {type: event.type, xid: event.xid, message};
                })
        },
        getStopsI18nMessagesByXid(state) {
            return [...state.stops, ...state.stops_last_hour]
                .reduce((eventsTextByXid, event) => {
                    let message = event?.message?.msg;
                    if (message) {
                        let matches = message.matchAll(/\$t{([\w]+)}/gi);
                        Array.from(matches).forEach(match => {
                            let str = event?.message[match[1]] || ''
                            let translateKey = 'message.' + 'events' + '.' + str
                            str = i18n.global.te(translateKey) ? i18n.global.t(translateKey) : str
                            message = message.replace(match[0], str);
                        })
                    }
                    eventsTextByXid[event.xid] = message;// || i18n.global.t('message.Unknown')//???
                    return eventsTextByXid;
                }, {})
        },
    }
}
